/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1550
 */

"use strict"

function r(e) {
  return e
}
export { r as a }
export default r
